/**
 * MIØ Rabatt-Pop-up (sections/mio-rabatt-popup.liquid).
 *
 * Erscheint einmal nach der eingestellten Zeit oder wenn die Maus am Desktop
 * das Fenster oben verlässt. Wartet, solange etwas anderes im Vordergrund
 * steht: Cookie-Banner oder -Einstellungen, Vorhang der Startseite, ein
 * anderes offenes Fenster (Suche, Warenkorb, Menü). Wer schließt oder den
 * Rabatt holt, sieht es PAUSE_TAGE nicht wieder.
 */

const SCHLUESSEL = 'mio-rabatt-popup';
const PAUSE_TAGE = 14;
const PRUEF_ABSTAND_MS = 800;
const KOPIERT_ZEIGEN_MS = 1600;

function zuletztGezeigt() {
  try {
    return Number(localStorage.getItem(SCHLUESSEL)) || 0;
  } catch {
    return 0;
  }
}

function merken() {
  try {
    localStorage.setItem(SCHLUESSEL, String(Date.now()));
  } catch {
    // Gesperrter Speicher: Das Pop-up kommt dann beim nächsten Besuch wieder.
  }
}

/** Steht gerade etwas anderes im Vordergrund? */
function besetzt(eigenes) {
  const sichtbar = (el) => el && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden';
  if (sichtbar(document.getElementById('shopify-pc__banner'))) return true;
  if (sichtbar(document.getElementById('shopify-pc__prefs__dialog'))) return true;
  if (document.getElementById('mio-vorhang')) return true;
  // Das Telefonmenü ist ein <details>, kein <dialog>.
  if (document.querySelector('#Details-menu-drawer-container[open], header details[open]')) return true;
  return [...document.querySelectorAll('dialog[open]')].some((d) => d !== eigenes);
}

class MioRabattPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.status = this.querySelector('[data-status]');
    if (!this.dialog) return;

    this.addEventListener('click', (e) => this.klick(e));
    // Klick auf den abgedunkelten Rand schließt.
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.schliessen();
    });

    if (this.hasAttribute('data-editor')) {
      // Im Theme-Editor sofort zeigen, damit sich Texte prüfen lassen.
      document.addEventListener('shopify:section:select', (e) => {
        if (this.closest('.shopify-section') === e.target) this.oeffnen(true);
      });
      return;
    }

    // Erst nach dem Editor-Zweig: Schließen im Editor soll keine Pause auslösen.
    this.dialog.addEventListener('close', () => merken());

    const pause = PAUSE_TAGE * 24 * 60 * 60 * 1000;
    if (Date.now() - zuletztGezeigt() < pause) return;

    this.faellig = false;
    window.setTimeout(() => {
      this.faellig = true;
    }, Number(this.dataset.verzoegerung) || 12000);

    // Am Desktop: Maus verlässt das Fenster nach oben.
    this.ausstieg = (e) => {
      if (e.clientY <= 0 && !e.relatedTarget) this.faellig = true;
    };
    if (window.matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', this.ausstieg);

    this.takt = window.setInterval(() => {
      if (this.faellig && !besetzt(this.dialog)) this.oeffnen();
    }, PRUEF_ABSTAND_MS);
  }

  disconnectedCallback() {
    window.clearInterval(this.takt);
    if (this.ausstieg) document.removeEventListener('mouseout', this.ausstieg);
  }

  oeffnen(editor = false) {
    window.clearInterval(this.takt);
    if (this.ausstieg) document.removeEventListener('mouseout', this.ausstieg);
    if (this.dialog.open) return;
    this.dialog.showModal();
    if (!editor) merken();
  }

  schliessen() {
    this.dialog.classList.add('is-schliessend');
    const fertig = () => {
      this.dialog.classList.remove('is-schliessend');
      this.dialog.close();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fertig();
    else window.setTimeout(fertig, 220);
  }

  async klick(e) {
    if (e.target.closest('[data-schliessen]')) {
      this.schliessen();
      return;
    }
    if (e.target.closest('[data-geholt]')) {
      merken();
      return;
    }
    const knopf = e.target.closest('[data-code]');
    if (!knopf || knopf.dataset.zeigt) return;
    try {
      await navigator.clipboard.writeText(knopf.dataset.code);
    } catch {
      return;
    }
    const wert = knopf.querySelector('.mio-popup__code-wert');
    knopf.dataset.zeigt = '1';
    wert.textContent = knopf.dataset.kopiert;
    if (this.status) this.status.textContent = `${knopf.dataset.code}: ${knopf.dataset.kopiert}`;
    window.setTimeout(() => {
      wert.textContent = knopf.dataset.code;
      delete knopf.dataset.zeigt;
      if (this.status) this.status.textContent = '';
    }, KOPIERT_ZEIGEN_MS);
  }
}

if (!customElements.get('mio-rabatt-popup')) customElements.define('mio-rabatt-popup', MioRabattPopup);
